module.exports = __webpack_public_path__ + "img/contraste3.c2a916d8.png";